/*
Code, hiérarchie et styles liés

https://codepen.io/LeonGr/pen/eYoZJB

Légerement modifié par Renaud R-B
*/

export default class Background {
  constructor(element) {
    this.element = element;
    this.noir = '#585858';
    this.blanc = '#fcfcfc';

    this.init();
  }

  init() {
    this.background();
    //console.log('bg');
  }

  background() {
    var canvas = document.getElementById('bg'),
      ctx = canvas.getContext('2d');

    let taille = 5000;
    //Breakpoint tablette
    if (window.matchMedia('(min-width: 800px)').matches) {
      canvas.width = taille;
      canvas.height = taille;
    } else {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    //Breakpoint tablette
    if (window.matchMedia('(min-width: 800px)').matches) {
      var stars = [], // Array that contains the stars
        FPS = 60, // Frames per second et vitesse
        x = 1000; // Number of stars
    } else {
      var stars = [], // Array that contains the stars
        FPS = 60, // Frames per second et vitesse
        x = 100; // Number of stars
    }

    // Push stars to array

    for (var i = 0; i < x; i++) {
      stars.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 1 + 1,
        vx: Math.floor(Math.random() * 50) - 25,
        vy: Math.floor(Math.random() * 50) - 25,
      });
    }

    // Draw the scene

    function draw() {
      // Add behind elements. https://stackoverflow.com/a/56085861
      // Now draw!

      ctx.fillStyle = '#fcfcfc';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.globalCompositeOperation = 'source-over';

      for (var i = 0, x = stars.length; i < x; i++) {
        var s = stars[i];

        ctx.fillStyle = '#fcfcfc';
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.radius, 0, 2 * Math.PI);
        ctx.fill();
        ctx.fillStyle = '#585858';
        ctx.stroke();
      }

      ctx.beginPath();
      for (var i = 0, x = stars.length; i < x; i++) {
        var starI = stars[i];
        ctx.moveTo(starI.x, starI.y);

        for (var j = 0, x = stars.length; j < x; j++) {
          var starII = stars[j];
          if (distance(starI, starII) < 150) {
            ctx.lineTo(starII.x, starII.y);
          }
        }
      }
      ctx.lineWidth = 0.05;
      ctx.strokeStyle = '#585858';
      ctx.stroke();
    }

    function distance(point1, point2) {
      var xs = 0;
      var ys = 0;

      xs = point2.x - point1.x;
      xs = xs * xs;

      ys = point2.y - point1.y;
      ys = ys * ys;

      return Math.sqrt(xs + ys);
    }

    // Update star locations

    function update() {
      for (var i = 0, x = stars.length; i < x; i++) {
        var s = stars[i];

        s.x += s.vx / FPS;
        s.y += s.vy / FPS;

        if (s.x < 0 || s.x > canvas.width) s.vx = -s.vx;
        if (s.y < 0 || s.y > canvas.height) s.vy = -s.vy;
      }
    }

    // Update and draw

    function tick() {
      draw();
      update();
      requestAnimationFrame(tick);
    }

    tick();
  }
}
new Background();
